export default __webpack_public_path__ + "static/media/Kahf1.35765afd.mp3";